import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { getOfferRequests, deleteOfferRequest } from "./modules/actions";

const mapStateToProps = (state) => ({
  state: {
    offerRequests: state.offerRequestReducer.offerRequests,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getOfferRequests,
      deleteOfferRequest,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
